<div class="mt-1 mb-3 flex align-items-center gap-5">
  <p-buttonGroup>
    @if (activeUserStore.canAccessConfig()) {
      <p-button
        size="small"
        severity="secondary"
        icon="fas fa-cogs"
        [rounded]="true"
        [outlined]="true"
        [routerLink]="[
          '/data-backend',
          {
            outlets: {
              overlay: ['konfiguration', { outlets: { panel: 'navigation' } }],
            },
          },
        ]"
        label="Navigation einstellen"></p-button>
      <p-button
        size="small"
        severity="secondary"
        icon="fas fa-link"
        [rounded]="true"
        [outlined]="true"
        [routerLink]="[
          '/data-backend',
          {
            outlets: {
              overlay: ['konfiguration', { outlets: { panel: 'links' } }],
            },
          },
        ]"
        label="Gast-Links"></p-button>
    }

    @if (activeUserStore.canAccessEntityAdder()) {
      <p-button
        size="small"
        severity="success"
        icon="fas fa-circle-plus"
        [rounded]="true"
        [outlined]="true"
        (click)="editBookmarkCategory(undefined)"
        label="Themenbereich"></p-button>

      <p-button
        size="small"
        severity="success"
        icon="fas fa-circle-plus"
        [rounded]="true"
        [outlined]="true"
        [routerLink]="[{ outlets: { bearbeiten: 'neu' } }]"
        label="Ansicht"></p-button>
    }

    <p-button
      size="small"
      severity="help"
      icon="fas fa-file-circle-check"
      [rounded]="true"
      [outlined]="true"
      (click)="openValidationPanel()"
      [badge]="invalidBookmarks()"
      badgeClass="p-badge-danger"
      label="Validierung"
      pTooltip="Öffentliche Ansichten auf Fehlkonfigurationen prüfen"></p-button>
  </p-buttonGroup>

  <div class="ml-auto flex gap-3">
    <label for="published"><i class="fas fa-earth-europe"></i></label>
    <p-triStateCheckbox
      id="published"
      (ngModelChange)="updateFilter()"
      [(ngModel)]="filterQuery.published"
      inputId="published" />
  </div>
  <div class="flex gap-3 align-items-center">
    <app-tag-filter-dropdown
      (selectedTagsChange)="updateFilter()"
      [(selectedTags)]="filterQuery.tags"></app-tag-filter-dropdown>
  </div>
  <div class="flex">
    <p-iconField iconPosition="left">
      <p-inputIcon styleClass="fas fa-search" />
      <input
        class="w-12rem"
        pInputText
        placeholder="durchsuchen ..."
        [(ngModel)]="filterQuery.query"
        (ngModelChange)="updateFilter()" />
    </p-iconField>
  </div>
</div>
<p-divider></p-divider>
<div class="grid">
  @if (bookmarkStore.groupedByCategory(); as groupedBookmarks) {
    @if (store.asSortedArray(); as categories) {
      @if (store.allKeys(); as ids) {
        <div class="col-3">
          <div class="grid">
            @if (bookmarkStore.private(); as privateBookmarks) {
              <div class="col-12">
                <div
                  class="align-items-center surface-200 border-round-top-2xl font-bold flex flex-column xl:flex-row p-3 gap-3">
                  <i class="fa-regular fa-eye-slash"></i> Privat
                </div>

                <app-bookmark-list
                  [bookmarks]="privateBookmarks"
                  [listId]="'private'"
                  [connectedTo]="ids"
                  (itemDropped)="drop($event)">
                </app-bookmark-list>
              </div>
              @if (
                initializedGroups(groupedBookmarks, store.private());
                as allGroups
              ) {
                <div
                  class="col-12"
                  *ngFor="let category of store.private(); trackBy: trackByKey">
                  <div
                    class="align-items-center surface-200 border-round-top-2xl font-bold flex flex-column xl:flex-row pl-3 py-1 pr-1 gap-3 word-wrap">
                    <i class="fas fa-layer-group"></i> {{ category.title }}
                    <p-button
                      [rounded]="true"
                      [text]="true"
                      severity="secondary"
                      class="ml-auto"
                      (click)="
                        onCategoryContextMenuOpen($event, category, categories);
                        cmenu.toggle($event)
                      "
                      icon="fas fa-ellipsis-vertical" />
                  </div>

                  <app-bookmark-list
                    [bookmarks]="allGroups[category._id]"
                    [listId]="category._id"
                    [connectedTo]="ids"
                    (itemDropped)="drop($event)">
                  </app-bookmark-list>

                  <p-menu
                    #cmenu
                    [model]="contextMenuBookmarkCategories"
                    [popup]="true"
                    appendTo="body" />
                </div>
              }
            }
          </div>
        </div>

        @if (initializedGroups(groupedBookmarks, categories); as allGroups) {
          <div class="col-9">
            <div class="grid">
              @if (bookmarkStore.unsorted(); as unsortedBookmarks) {
                <div class="col-4">
                  <div
                    class="align-items-center surface-100 border-round-top-2xl font-bold flex flex-column xl:flex-row p-3 gap-3">
                    <i class="fas fa-layer-group"></i>
                    <span>nicht zugeordnet</span>
                  </div>
                  <app-bookmark-list
                    [bookmarks]="unsortedBookmarks"
                    [listId]="'unsorted'"
                    [connectedTo]="ids"
                    (itemDropped)="drop($event)">
                  </app-bookmark-list>
                </div>
              }
              <div
                class="col-4"
                *ngFor="let category of categories; trackBy: trackByKey">
                <div
                  class="align-items-center bg-primary border-round-top-2xl font-bold flex flex-column xl:flex-row pl-3 pr-1 py-1 gap-3 word-wrap">
                  <i class="fas fa-layer-group"></i> {{ category.title }}
                  <i
                    *ngIf="atlasNavigation.includes(category._id)"
                    class="fas fa-info-circle"
                    pTooltip="In Navigation abgebildet"></i>
                  <p-button
                    [rounded]="true"
                    severity="primary"
                    class="ml-auto"
                    (click)="
                      onCategoryContextMenuOpen($event, category, categories);
                      cmenu.toggle($event)
                    "
                    icon="fas fa-ellipsis-vertical" />
                </div>

                <app-bookmark-list
                  [bookmarks]="allGroups[category._id]"
                  [listId]="category._id"
                  [connectedTo]="ids"
                  (itemDropped)="drop($event)">
                </app-bookmark-list>

                <p-menu
                  #cmenu
                  [model]="contextMenuBookmarkCategories"
                  [popup]="true"
                  appendTo="body" />
              </div>
            </div>
          </div>
        }
      }
    }
  }
</div>

<p-sidebar
  (onHide)="onOverlayClose()"
  position="right"
  [modal]="false"
  [styleClass]="'w-5'"
  [visible]="editFormOverlay">
  <ng-template pTemplate="header">
    <app-header
      [icon]="editFormOverlayIcon"
      [text]="editFormOverlayHeader"></app-header
  ></ng-template>

  <ng-container *ngIf="editFormOverlay">
    <router-outlet name="bearbeiten"></router-outlet>
  </ng-container>
</p-sidebar>
<app-mask [visible]="editFormOverlay" (click)="onOverlayClose()"></app-mask>

<!-- Bookmark Validation Panel -->
<app-bookmark-validation-panel></app-bookmark-validation-panel>
